import React from "react";
import { Link } from "react-router-dom";

import "../../images/css/NotFound.css";
import ChatHeader from "./ChatHeader";
import ChatSidebar from "./ChatSidebar";
import Disclaimer from "./Disclaimer";

interface CommonPageComponentsProps {
  iconText?: string;
  titleText: string;
  msgText: string;
  buttonText: string;
  buttonLink: string;
  onClick?: () => void;

}

const CommonPageComponents: React.FC<CommonPageComponentsProps> = ({ iconText, titleText, msgText, buttonText, buttonLink, onClick }) => {
  return (
    <div>
      <ChatHeader />
      <div className="chat-row-container flex-columns columns-full">
        <ChatSidebar />
        <main className="max-w-4xl mx-auto p-6 h-100dvh">
          <div className="not-found-container">
            <div className="not-found-content">
              <div className="error-container">
                <h1 aria-hidden="true">{iconText}</h1>
                <h3 className="not-found-title">{titleText}</h3>
                <h4 className="not-found-text">{msgText}</h4>
                {onClick ? (
                  <Link to={buttonLink} className="btn-primary" onClick={onClick}>{buttonText}</Link>
                ) : (
                  <Link to={buttonLink} className="btn-primary">{buttonText}</Link>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
      <Disclaimer />
    </div>
  );
};

export default CommonPageComponents;
